function removeDomainFromLoginName(loginName: string) {
  return loginName.indexOf("\\") > -1 ?
    loginName.substring(loginName.indexOf("\\") + 1)
    : loginName;
}

export class ComparableLoginNameConverter {
  toView(value) {
    return removeDomainFromLoginName(value).toLowerCase();
  }
}
